import { Flex, Space, Typography } from "antd"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import theme from "../styles/theme"
import SearchModal from "./SearchModal"
import SocialLinks from "./SocialLinks"

const { Title } = Typography

const Header: React.FC<{ siteTitle: string }> = ({
  siteTitle: fallbackTitle,
}) => {
  const data = useStaticQuery(graphql`
    query {
      strapiSiteSetting {
        siteTitle
      }
    }
  `)

  const siteTitle = data.strapiSiteSetting?.siteTitle || fallbackTitle
  const logoImage = null // Use static image until Strapi is populated
  const logoAlt = siteTitle

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        background: theme.colorBgBase,
      }}
    >
      {/* Top colored bar with social links */}
      <div
        style={{
          width: "100%",
          background: theme.primaryColor,
          padding: "0.5rem 1rem",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <SocialLinks />
      </div>

      {/* Main header with logo and search */}
      <header
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "0.5rem 1rem",
          background: theme.colorBgBase,
        }}
      >
        <Flex justify="space-between" align="center" style={{ width: "100%" }}>
          <Link to="/">
            <Space>
              {logoImage ? (
                <GatsbyImage
                  image={logoImage}
                  alt={logoAlt}
                  style={{
                    position: "relative",
                    backgroundImage: `radial-gradient(circle at center, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    maxWidth: "7rem",
                    maxHeight: "7rem",
                  }}
                />
              ) : (
                <StaticImage
                  src="../images/logo.png"
                  alt={siteTitle}
                  placeholder="blurred"
                  style={{
                    position: "relative",
                    backgroundImage: `radial-gradient(circle at center, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    maxWidth: "7rem",
                    maxHeight: "7rem",
                  }}
                />
              )}
              <Title level={1} style={{ color: theme.primaryColor }}>
                {siteTitle}
              </Title>
            </Space>
          </Link>
          <SearchModal />
        </Flex>
      </header>
    </div>
  )
}

export default Header
